import type { CogsPageCalcState } from "./useCogsPageMaterialsCalc";

type Props = {
  pageCalc: CogsPageCalcState | null;
  loading: boolean;
  backgroundFill: boolean;
  onExpand: () => void;
  onContinue: () => void;
};

function statusText(props: Props): string {
  if (props.loading && !props.pageCalc) return "Loading this page.";
  if (!props.pageCalc) return "Working on material costs.";
  if (props.pageCalc.background) {
    return `${props.pageCalc.done} products on later pages saved. Still filling ahead.`;
  }
  if (props.pageCalc.phase === "saving") return "Opening the totals just saved for this page.";
  if (props.backgroundFill) {
    return `${props.pageCalc.done} of ${props.pageCalc.total} products on this page saved. Later pages start after this.`;
  }
  return `${props.pageCalc.done} of ${props.pageCalc.total} products on this page saved.`;
}

export function ManufacturingPricingCalcClock(props: Props) {
  const status = statusText(props);
  return (
    <div className="group relative">
      <button
        type="button"
        className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-indigo-300 bg-indigo-50 text-indigo-800 hover:bg-indigo-100 dark:border-indigo-700 dark:bg-indigo-950/50 dark:text-indigo-100 dark:hover:bg-indigo-950"
        aria-label="Material costs are still calculating. Show progress."
        title={status}
        onClick={props.onExpand}
      >
        <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
          <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="1.8" />
          <path d="M12 7.5V12l3 2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      </button>
      <div className="absolute left-0 top-full z-30 hidden pt-1 group-hover:block group-focus-within:block">
        <div className="w-72 rounded-xl border border-gray-200 bg-white p-3 text-left shadow-lg dark:border-zinc-700 dark:bg-zinc-900">
          <p className="text-xs text-gray-600 dark:text-zinc-300">{status}</p>
          {props.pageCalc && !props.backgroundFill && !props.pageCalc.background ? (
            <button
              type="button"
              className="mt-2 text-left text-xs font-medium text-indigo-800 underline-offset-2 hover:underline dark:text-indigo-200"
              onClick={props.onContinue}
            >
              Continue filling in models in the background
            </button>
          ) : props.backgroundFill || props.pageCalc?.background ? (
            <p className="mt-2 text-xs font-medium text-indigo-800 dark:text-indigo-200">
              Filling later pages in the background.
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
